/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { AxiosHttpError, ERROR_MESSAGES } from 'utility/errors';
import PropTypes from 'prop-types';
import { FALLBACK_ERROR_MESSAGE } from 'constants/error/clientError.constants';

import '../universalComponents.scss';
import StatusMessage, { STATUS_MESSAGE_VARIANTS } from '../StatusMessage';

function RenderErrorPreview({ errorMessage, error, notFoundPreview }) {
  const isAxiosError = error instanceof AxiosHttpError;
  const isNotFound = isAxiosError && error.statusCode === 404;

  if (isNotFound && notFoundPreview) {
    return notFoundPreview;
  }

  const message =
    (isAxiosError && error.errorMessage) ||
    errorMessage ||
    FALLBACK_ERROR_MESSAGE;
  const variant =
    isNotFound || message === ERROR_MESSAGES[404]
      ? STATUS_MESSAGE_VARIANTS.NO_DATA
      : STATUS_MESSAGE_VARIANTS.TECHNICAL_ISSUE;

  return (
    <div className="row universal-error" data-testid="error">
      <div className="col-12 py-3 d-flex justify-content-center">
        <StatusMessage variant={variant} message={message} />
      </div>
    </div>
  );
}

RenderErrorPreview.propTypes = {
  errorMessage: PropTypes.string,
  error: PropTypes.object.isRequired,
  notFoundPreview: PropTypes.node,
};

RenderErrorPreview.defaultProps = {
  errorMessage: FALLBACK_ERROR_MESSAGE,
  notFoundPreview: null,
};
export default RenderErrorPreview;
